import { enUS as coreEnUS, zhCN as coreZhCN, jaJP as coreJaJP } from "@mui/material/locale";
import { enUS as gridEnUS, zhCN as gridZhCN, jaJP as gridJaJP } from "@mui/x-data-grid/locales";
import {
  enUS as pickersEnUS,
  zhCN as pickersZhCN,
  jaJP as pickersJaJP,
} from "@mui/x-date-pickers/locales";

/** Only bundles used by LANGUAGEMAP.mui — avoids pulling every MUI locale into the main chunk. */
export const muiLocaleBundles = {
  enUS: { core: coreEnUS, grid: gridEnUS, pickers: pickersEnUS },
  zhCN: { core: coreZhCN, grid: gridZhCN, pickers: pickersZhCN },
  jaJP: { core: coreJaJP, grid: gridJaJP, pickers: pickersJaJP },
} as const;

export type MuiLocaleBundleKey = keyof typeof muiLocaleBundles;
